import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { RunningExperiments, useExperiments } from 'state/experiments';

interface UseMenuLayoutUpdatesPhaseTwoProps {
  skipLogExposure?: boolean;
}

enum ExperimentVariants {
  TREATMENT = 'treatment',
}

export const useMenuLayoutUpdatesPhaseTwo = ({
  skipLogExposure = false,
}: UseMenuLayoutUpdatesPhaseTwoProps = {}): boolean => {
  const experiment = RunningExperiments.MenuLayoutUpdatesPhaseTwo;
  const { variant, getVariantValue } = useExperiments();
  const isMobile = useIsMobileBreakpoint();

  if (skipLogExposure) {
    const { value } = getVariantValue(experiment) || {};
    return value === ExperimentVariants.TREATMENT && isMobile;
  }

  return variant(experiment, ExperimentVariants.TREATMENT);
};
